import { render, staticRenderFns } from "./Sorter.vue?vue&type=template&id=3ad4a98e&"
import script from "./Sorter.vue?vue&type=script&lang=js&"
export * from "./Sorter.vue?vue&type=script&lang=js&"
import style0 from "./Sorter.vue?vue&type=style&index=0&id=3ad4a98e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports